document.addEventListener('DOMContentLoaded', (event) =>{
	let selectFrMenuItem = document.querySelectorAll('li[id*="_fr"]');
	let selectFrSbMenuItem = document.querySelectorAll('div[id*="fxrsb_fr"]');

	// DESKTOP MAIN MEGA MENU, HIDE THE FR TEXT
	for(let i=0; i<selectFrMenuItem.length; i++){
		let getFrMenuItemChildren = selectFrMenuItem[i].children[0]; 
		let getFrMenuItemChildrenText = getFrMenuItemChildren.innerHTML; 
		const newFrMenuText = getFrMenuItemChildrenText.replace('FR','');
		getFrMenuItemChildren.innerHTML = newFrMenuText;
	}

	//  SIDE BAR MENU, HIDE THE FR TEXT
	for(let i=0; i<selectFrSbMenuItem.length; i++){
	let getFrSbTitle = selectFrSbMenuItem[i].children[0].innerHTML;
	let newFrSbTitle = getFrSbTitle.replace('FR', '');
	selectFrSbMenuItem[i].children[0].innerHTML = newFrSbTitle;
	} 
})

$(document).ready(function () {

	// GLOBAL VARIABLES
	const frCheckURL = window.location.href;

	// GSAP code
	gsap.registerPlugin(ScrollTrigger);

	const boxes = gsap.utils.toArray(".scrollFade");
	const boxesNoScrub = gsap.utils.toArray(".fadeNoScrub");

	// GSAP: Fade In
	boxes.forEach((box, i) => {
		const anim = gsap.fromTo(
			box,
			{
				opacity: 0,
			},
			{
				opacity: 1,
			}
		);
		ScrollTrigger.create({
			trigger: box,
			animation: anim,
			scrub: true,
			start: "top 80%",
			end: "top end",
		});
	}); // end of Fade

/*===== MAIN PAGE ======= */

	// Switch Content Button
	const frBannerMoto = $("*[id*=483ddb7d-1281-4e86-b4d2-5864d9b7368c]");
	const frBannerSnow = $("*[id*=8a98fe6d-b6bd-4e2a-8177-01654c9d808a]");
	const frSlideMoto = $("*[id*=4c03212d-1115-4bae-b106-23c46be3afed]");
	const frSlideSnow = $("*[id*=82a00ea9-809b-4b8b-acec-6b94a7eab5eb]");

	frSlideSnow.hide();
	frBannerSnow.hide();

	$(".frSwitch__bttn").each(function () {
		$(this).on("click", function () {
			// Variables
			let frSwitchButton = $(".frSwitch__bttn");
			let frSwitchButtonText = $(".frSwitch__bttnTxt");
			let frSwitchButtonImage = $(".frSwitch__bttnImage");

			// check if user has selected a passion
			if (!$(this).hasClass("active")) {
				frSwitchButtonImage.removeClass("colored");
				frSwitchButtonText.addClass("frGrey");
				frSwitchButton.removeClass("active");

				if ($(this).hasClass("frSwitch__bttn--moto")) {
					$(".frInsideContent__snow").css("display", "none");
					$(".frInsideContent__moto").css("display", "block");
					frBannerMoto.show();
					frBannerSnow.hide();
					frSlideMoto.show();
					frSlideSnow.hide();
					ScrollTrigger.refresh();

					$(this.children[0]).toggleClass("colored");
					$(this.children[1]).toggleClass("frGrey");
					$(this).addClass("active");
					// console.log("selected moto");

				} else if ($(this).hasClass("frSwitch__bttn--snow")) {
					$(".frInsideContent__snow").css("display", "block");
					$(".frInsideContent__moto").css("display", "none");
					frBannerMoto.hide();
					frBannerSnow.show();
					frSlideMoto.hide();
					frSlideSnow.show();
					ScrollTrigger.refresh();

					$(this.children[0]).toggleClass("colored");
					$(this.children[1]).toggleClass("frGrey");
					$(this).addClass("active");
					// console.log("selected snow");
				} else {
				}
			} else {
			}
		});
	});

	
}); // end of script
